<template>
  <baidu-map id="mapContainer" ref="mapContainer" class="map_confirm" center="上海" :scroll-wheel-zoom="map.scrollWheelZoom"
    :dragging="map.dragging" :double-click-zoom="map.dbClickZoom" :mapStyle="map.mapStyle" @ready="ready" @click="mapClick">

    <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>

    <bm-control :offset="{width:5,height:5}" style="display:inline;">
      <tr valign="top">
        <td style="width:120px">
          <el-select v-model="selectedRadioIdx" placeholder="选择频率" @change="handleSelectChange" size="small">
            <el-option v-for="(radio,idx) in radios" :key="radio.id" :label="`${radio.frequency} ${radio.confirm}`"
              :value="idx">
            </el-option>
          </el-select>
        </td>
        <td style="width:350px;padding-left:7px;">
          <el-button-group>
            <el-tooltip effect="light" content="显示当前所选非法电台的详细信息" :hide-after="2000">
              <el-button size="small" type="info" @click="radioInfo()">电台信息</el-button>
            </el-tooltip>
            <el-tooltip effect="light" content="显示扫描到所选电台频率的终端设备" :hide-after="2000">
              <el-button size="small" type="primary" @click="scanDevice()">扫描终端</el-button>
            </el-tooltip>
            <el-tooltip effect="light" content="手动添加系统未监测到，但经过外部确认的非法电台" :hide-after="2000">
              <el-button size="small" type="success" @click="isAddingRadioShow=true;">手动添加</el-button>
            </el-tooltip>
            <el-button size="small" type="warning" @click="getPointShow=true;">坐标拾取</el-button>
          </el-button-group>
        </td>
        <td style="width:380px;">
          <el-input v-show="getPointShow" size="small" placeholder="点击地图获取坐标" v-model="getPointLocation">
            <template slot="prepend" style="padding:0;">当前坐标：</template>
            <template slot="append">
              <el-button style="padding:0 8px;" size="small" type="primary" @click="copyLcation()">复制</el-button>
              <el-button style="padding:0 8px;" size="small" type="primary" @click="getPointShow=false;">关闭</el-button>
            </template>
          </el-input>
        </td>
      </tr>
    </bm-control>

    <bm-marker v-for="radio in radios" @click="showinfowindow_radio(radio)" :icon="icons[radio.confirm]" :key="radio.id"
      :title="String(radio.frequency)" :position="{lng: radio.lon, lat: radio.lat}">
    </bm-marker>

    <bm-info-window title="电台信息" :show="infowindow_radio.show" :position="infowindow_radio.position" :width="380" @open="infowindow_radio.show=true;"
      @close="infowindow_radio.show=false;">
      <el-form size="medium">
        <el-row>
          <el-col :span="6">
            <el-form-item label="频率">
              <el-tag :style="tagStyle">{{infowindow_radio.data.frequency}}</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="状态">
              <el-tag :style="tagStyle">{{infowindow_radio.data.confirm}}</el-tag>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-tooltip effect="light" content="电台位置计算或确认时间" placement="bottom" :hide-after="2000">
              <el-form-item label="时间">
                <el-tag :style="tagStyle">{{infowindow_radio.data.time}}</el-tag>
              </el-form-item>
            </el-tooltip>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="坐标">
            <el-tag :style="tagStyle+'width:338px;'">{{`${infowindow_radio.data.lon} , ${infowindow_radio.data.lat}`}}</el-tag>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="描述">
            <el-tag :style="tagStyle+'width:338px;'">{{infowindow_radio.data.detail}}</el-tag>
          </el-form-item>
        </el-row>
        <el-form-item>
          <el-button plain size="mini" type="primary" @click="changeLocation()">修改坐标</el-button>
          <el-button plain size="mini" type="primary" @click="changeDetail()">修改描述</el-button>
          <el-button plain size="mini" type="primary" @click="confirmAndSave()">确认并保存</el-button>
        </el-form-item>
      </el-form>
    </bm-info-window>

    <el-dialog title="手动添加非法电台" :visible.sync="isAddingRadioShow" width="500px" :close-on-click-modal="false">
      <el-form size="medium" label-width="50px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="频率">
              <el-input size="small" v-model="newRadio.freq"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="坐标">
              <el-input size="small" v-model="newRadio.location" placeholder="经纬度坐标，逗号分隔"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="描述">
          <el-input size="small" v-model="newRadio.detail"></el-input>
        </el-form-item>
        <el-form-item style="padding-top:10px;">
          <el-button plain size="medium" type="primary" @click="addRadio()">确认</el-button>
          <el-button plain size="medium" type="primary" @click="isAddingRadioShow=false;">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <bm-info-window title="设备信息" :show="infowindow_device.show" :position="infowindow_device.position" :width="430"
      @open="infowindow_device.show=true;" @close="infowindow_device.show=false;">
      <device-detail :lgid="infowindow_device.device_lgid"></device-detail>
    </bm-info-window>

    <bm-marker :position="selectedRadioPos" :icon="icons['已选择']" :zIndex="0"></bm-marker>

    <bm-marker v-for="device in devices" :key="'m'+device.lgid" :position="device.position" :title="device.lgid" @click="showinfowindow_device(device)"></bm-marker>

    <bm-polyline v-for="device in devices" :key="'p'+device.lgid" :path="device.path" stroke-color="red"
      :stroke-opacity="0.5" :stroke-weight="2"></bm-polyline>
    <bm-label v-for="(label,index) in labels" :key="'l'+index" :content="label.content" :position="label.position"
      :labelStyle="{color: 'red', fontSize : '20px',fontWeight:'bold',backgroundColor:'rgba(0,0,0,0)',border:0}"
      :offset="{width:-27,height:-12}" />

  </baidu-map>
</template>
<script>
  import DeviceDetail from "@/components/Form/DeviceDetail";
  export default {
    components: {
      DeviceDetail
    },
    watch: {
      getPointShow(value) {
        if (value) {
          this.map.mapInstance.setDefaultCursor("crosshair");
        } else {
          this.map.mapInstance.setDefaultCursor(this.map.mapCursorDefault);
        }
      }
    },
    data() {
      return {
        tagStyle: "background-color:#fff;color:#999;height:22px;line-height:20px;",
        // 地图容器参数
        map: {
          mapInterface: null, //BMap类
          mapInstance: null, //map实例
          scrollWheelZoom: true,
          dragging: true,
          dbClickZoom: false,
          mapStyle: null,
          mapCursorDefault: null
        },
        icons: {
          已确认: {
            url: "/image/radio_confirmed.png",
            size: {
              width: 32,
              height: 32
            }
          },
          待确认: {
            url: "/image/radio_unconfirmed.png",
            size: {
              width: 32,
              height: 32
            }
          },
          已选择: {
            url: "/image/radio_wave.gif",
            size: {
              width: 100,
              height: 100
            }
          }
        },
        radios: [], //所有的设备
        selectedRadioIdx: "",
        infowindow_radio: {
          show: false,
          position: {},
          data: {}
        },
        infowindow_device: {
          show: false,
          position: {},
          device_lgid: null
        },
        devices: [],
        labels: [],
        getPointShow: false,
        getPointLocation: null,
        isAddingRadioShow: false, // 添加电台的弹窗显示
        newRadio: {
          freq: '',
          location: '',
          detail: ''
        }
      };
    },
    computed: {
      selectedRadioPos: function () {
        if (this.radios[this.selectedRadioIdx]) {
          return {
            lng: this.radios[this.selectedRadioIdx].lon,
            lat: this.radios[this.selectedRadioIdx].lat
          };
        } else {
          return {};
        }
      }
    },
    created() {
      this.$getJSON("/admin/readFile", {
        path: "mapStyle/GIS.json",
        encoding: "utf8"
      }).then(res => (this.map.mapStyle = JSON.parse(res.data)));
    },
    mounted() {},
    methods: {
      ready(params) {
        //获取百度地图的实例 待用
        this.map.mapInterface = params.BMap;
        this.map.mapInstance = params.map;

        this.map.mapCursorDefault = params.map.getDefaultCursor(); //地图的鼠标指针样式

        //计算并绘制网格密度
        this.getData();
      },

      mapClick(e) {
        // 点击地图获取坐标
        if (this.getPointShow) {
          this.getPointLocation = `${e.point.lng} , ${e.point.lat}`;
        }
        // 点击地图手动添加电台
        if (this.isAddingRadio) {
          this.isAddingRadioShow = true;
        }
      },

      copyLcation() {
        if (!this.getPointLocation) {
          this.$message({
            message: "坐标为空",
            type: "info"
          });
          return;
        }
        this.$copyText(this.getPointLocation).then(
          res => {
            this.$message({
              message: "坐标已复制到粘贴板",
              type: "success"
            });
          },
          err => {
            this.$message({
              message: "复制坐标时出错",
              type: "error"
            });
          }
        );
      },

      //获取设备信息 以设置密度信息 并将最终密度网格添加到地图
      getData() {
        this.$getJSON("/radio/s_illegalRadio", {}).then(res => {
          this.radios = res.data;
        });
      },

      showinfowindow_radio(radio) {
        //在地图上显示非法电台的详细信息
        this.infowindow_radio.position.lng = radio.lon;
        this.infowindow_radio.position.lat = radio.lat;
        this.infowindow_radio.data = JSON.parse(JSON.stringify(radio));
        this.infowindow_radio.show = true;
      },

      showinfowindow_device(device) {
        this.infowindow_device.position = device.position;
        this.infowindow_device.device_lgid = device.lgid;
        this.infowindow_device.show = true;
      },

      handleSelectChange(value) {
        this.selectedRadioIdx = value;
        //在下拉框选择电台后 地图中心定位到电台的位置
        this.center(this.radios[this.selectedRadioIdx]);
      },

      center(radio) {
        let BMap = this.map.mapInterface;
        let map = this.map.mapInstance;
        let pnt = new BMap.Point(radio.lon, radio.lat);
        map.panTo(pnt, {
          noAnimation: false
        });
      },

      checkSelect() {
        //检查下拉框是否有选择值   有则返回true 反之false
        if (this.selectedRadioIdx === "") {
          this.$message({
            message: "请在下拉框中选择非法电台",
            type: "warning"
          });
          return false;
        }
        return true;
      },

      radioInfo() {
        //定位并显示电台信息
        if (this.checkSelect()) {
          this.center(this.radios[this.selectedRadioIdx]);
          this.showinfowindow_radio(this.radios[this.selectedRadioIdx]);
        }
      },

      scanDevice() {
        //获取扫描到所选电台的终端设备 并在地图上标示出来
        if (!this.checkSelect()) return;
        let BMap = this.map.mapInterface;
        let map = this.map.mapInstance;
        this.devices = [];
        this.labels = [];
        this.$getJSON("/radio/radioScanDevices", {
          freq: this.radios[this.selectedRadioIdx].frequency
        }).then(res => {
          let pntAll = []; //保存电台以及终端的位置 用以设置最后的地图可视范围
          let radioLca = {
            lng: this.radios[this.selectedRadioIdx].lon,
            lat: this.radios[this.selectedRadioIdx].lat
          }; //电台的位置
          let radioPnt = new BMap.Point(radioLca.lng, radioLca.lat);
          pntAll.push(radioPnt);

          for (let i = 0; i < res.data.length; i++) {
            let device = {};
            device.lgid = res.data[i].device_lgid;
            let deviceLca = {
              lng: res.data[i].lon,
              lat: res.data[i].lat
            }; //终端位置
            device.position = deviceLca;
            let devicePnt = new BMap.Point(deviceLca.lng, deviceLca.lat);
            pntAll.push(devicePnt);
            device.path = [radioLca, deviceLca]; //电台与终端的连线 用以在地图上画线
            this.devices.push(device);

            let dis = map.getDistance(radioPnt, devicePnt); //电台与终端的距离 以标注形式显示在地图上
            let label = {};
            label.content = `${Math.round(dis / 100) / 10}KM`;
            label.position = {
              lng: (radioLca.lng + deviceLca.lng) / 2,
              lat: (radioLca.lat + deviceLca.lat) / 2
            }; //标注的位置
            this.labels.push(label);
          }
          map.setViewport(pntAll);
        });
      },

      changeLocation() {
        this.$prompt("请输入坐标（格式：经度,纬度）", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputValidator: function (value) {
              value = value.trim();
              let errMsg = "坐标值不合法";
              let location = value.split(",");
              if (location.length != 2) return errMsg;
              if (location[0] == "" || location[1] == "") return errMsg;
              location = location.map(s => Number(s));
              let lon = location[0];
              let lat = location[1];
              if (Number.isNaN(lon) || Number.isNaN(lat)) return errMsg;
              if (lon < -180 || lon > 180 || lat < -90 || lat > 90) return errMsg;
              return true;
            }
          })
          .then(value => {
            let location = value.value.split(",").map(s => Number(s));
            this.infowindow_radio.data.lon = location[0];
            this.infowindow_radio.data.lat = location[1];
          })
          .catch(() => {});
      },

      changeDetail() {
        this.$prompt("请输入描述", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消"
          })
          .then(value => {
            this.infowindow_radio.data.detail = value.value;
          })
          .catch(() => {});
      },

      confirmAndSave() {
        // if (this.infowindow_radio.data.confirm == "已确认") {
        //   this.$message({
        //     message: "电台已经过确认",
        //     type: "warning"
        //   });
        //   return;
        // }
        this.$confirm("确认并保存此黑电台信息, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            this.$getJSON("/radio/u_illegalRadio", this.infowindow_radio.data).then(
              res => {
                this.$message.success("确认成功,请刷新页面以更新信息");
              }
            );
          })
          .catch(() => {});
      },

      // 手动添加非法电台
      addRadio() {
        if (this.newRadio.freq == '') {
          this.$message.error("频率不能为空");
          return;
        }
        if (this.newRadio.location == '') {
          this.$message.error("坐标不能为空");
          return;
        }
        if (this.newRadio.location.split(',').length != 2) {
          this.$message.error("坐标格式不正确");
          return;
        }
        this.newRadio.lon = this.newRadio.location.split(',')[0];
        this.newRadio.lat = this.newRadio.location.split(',')[1];
        this.$confirm("确认并保存此黑电台信息, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            this.$getJSON("/radio/i_illegalRadio", this.newRadio).then(
              res => {
                this.$message.success("确认成功,请刷新页面以更新信息");
                this.isAddingRadioShow = false;
              }
            );
          })
          .catch(() => {});
      }
    }
  };

</script>
<style>
  .map_confirm {
    width: 100%;
    height: 100%;
  }

  .map_confirm .el-form-item {
    margin: 0;
  }

  .map_confirm .el-form-item .el-button {
    margin-top: 5px;
    padding: 4px 6px;
    margin-left: 0;
  }

  .map_confirm .anchorBL {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/IllegalRadioConfirm.vue